import { CampaignPublicView, CommunityViewPublic } from "@bbb/model";
import { getLatestCampaignStatus, toEpochMs } from "@bbb/utils";
import { EpochMs } from "@bbb/utils/datetime";


/**
 * A campaign is considered "published" once it is scheduled, live, or ended.
 * This replaces the old deposit-based check.
 */
export function isPublishedCampaign(
  campaign: CampaignPublicView,
): boolean {
  if (!campaign) return false;
  const status = getLatestCampaignStatus(campaign);
  return status === "scheduled" || status === "live" || status === "ended";
}

export function hasPublishedCampaigns(
  campaigns: CampaignPublicView[],
): boolean {
  return campaigns.some((campaign) => isPublishedCampaign(campaign));
}

export function hasLiveCampaigns(
  campaigns: CampaignPublicView[],
  today: EpochMs = toEpochMs(new Date()),
): boolean {
  return campaigns.some(
    (campaign) => getLatestCampaignStatus(campaign, today) === "live",
  );
}

export function hasEndedCampaigns(
  campaigns: CampaignPublicView[],
  today: EpochMs = toEpochMs(new Date()),
): boolean {
  return campaigns.some(
    (campaign) => getLatestCampaignStatus(campaign, today) === "ended",
  );
}

export function matchesCampaignSearchQuery(
  searchQuery: string,
  community: Pick<CommunityViewPublic, "profile">,
  campaign: Pick<CampaignPublicView, "name" | "description">,
): boolean {
  const normalizedQuery = searchQuery.trim().toLowerCase();

  if (normalizedQuery === "") {
    return true;
  }

  const searchableFields = [
    community.profile.name,
    community.profile.bio ?? "",
    campaign.name,
    campaign.description ?? "",
  ];

  return searchableFields.some((value) =>
    value.toLowerCase().includes(normalizedQuery),
  );
}
